import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api, useAuth } from "../App";
import { pendingPromotion, PENDING_PROMOTION_KEY, rememberClaimedPromotion } from "../lib/referrals";
import { toast } from "../lib/toast";

export default function PromotionCapture() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const running = useRef(false);
  useEffect(() => {
    const code = pendingPromotion();
    if (!user || !code || running.current) return;
    running.current = true;
    api.post("/promotions/claim", { code }).then(({ data }) => {
      rememberClaimedPromotion(user.id, data.code, data.expires_at);
      localStorage.removeItem(PENDING_PROMOTION_KEY);
      toast.success(data.message);
    }).catch(error => {
      if (error.response?.status === 400) {
        localStorage.removeItem(PENDING_PROMOTION_KEY);
        toast.info(error.response.data.detail);
      }
    }).finally(() => { running.current = false; });
  }, [user, pathname]);
  return null;
}
